// import { compareBuild } from "semver"
export default {
  install(Vue, options) {
    Vue.prototype.$APIjs = {
      url:jsonObject.BackEndServer,
      mjpgurl:jsonObject.MJPGServer,
      alcoholTesterAPIKey:jsonObject.AlcoholTesterAPIKey,
      dataobj:[],
      accounttoken:'',
      LangObj:[],
      username:'',
      invalid_token_to_login:'',
      ManageLangObj:[],
      //獲得token
      GetNewAccountToken:function(token,Username){
        var this_=this
        Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'auth/tokenCheck?accessToken='+token.split(' ')[1],
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          // xhrFields: { withCredentials: true },
          success: function (data) {
            //console.log(data.token_type+' '+data.access_token)
            var token = data.token_type+' '+data.access_token 
            localStorage.setItem('token',token)
          },
          error: function (data, status, statusText) {
            if(data.responseJSON.error_description == 'Timeout'){
              // Vue.prototype.$router.push({ name: 'Login' }).catch(()=>{})
              // window.location.href = jsonObject['LoginCenter']+jsonObject['SolutionName']+'&Type=Logout'
              Vue.prototype.$Global.Logout('Logout')
            }
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        });
      },
      //使用Token登入
      TokenLogin:async function(token){
        var this_=this
        var result= ''
        await Vue.prototype.$.ajax({
          type: 'POST',
          // url: this.url+'auth/tokenCheck?Username='+Username+'&accessToken='+token.split(' ')[1],
          url: this.url+'auth/tokenCheck?accessToken='+token.split(' ')[1],
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (response) {
            result = response;
            this_.accounttoken = result.token_type + ' ' +result.access_token
            Vue.prototype.$cookie.set('ul',btoa('SYS'+response.userlevel+'TECH'))
            localStorage.setItem('token',this_.accounttoken)
            localStorage.setItem('username',response.userName)
            localStorage.setItem('logourl',response.logourl)
            localStorage.setItem('PKUserID',response.userID)
            if(response.pK_V4_LoginIndex){
              localStorage.setItem('LoginIndex',response.pK_V4_LoginIndex)
            }
            this_.username = response.username
          },
          error: function (data, status, statusText) {
            result = data
            Vue.prototype.$Global.Logout('Logout')
            // window.location.href = jsonObject['LoginCenter']+jsonObject['SolutionName']+'&Type=Logout'
            // Vue.prototype.$router.push({ name: 'Login' }).catch(()=>{})
          }
        });
        return result
      },
      //token 錯誤
      InvalidToken:function(data){
        if(data.getResponseHeader('WWW-Authenticate') != null){
          this.invalid_token_to_login = 'Login'
        }
      },
      //組URL字串
      GetAPIUrlArray:function(variablename,Array){
        var url='';
        for(var i = 0 ;i <Array.length;i++){
          if(i == 0){
            url = url + '?'+variablename+'='+Array[i]
          }else{
            url = url + '&'+variablename+'='+Array[i]
          }
        }
        return url
      },
      //單元測試
      UnitTest:function(){
        // this.GetLogoAddress('testGroup',localStorage.getItem('token'))
        // this.GetPriority(localStorage.getItem('token'))
        // this.GetFleet(localStorage.getItem('token'))
        // this.GetCarInfoFleet('142',localStorage.getItem('token'))
        // this.GetCarInfoUnit('1014207026',localStorage.getItem('token'))
        // this.GetCarUnitStatusFleet('142',localStorage.getItem('token'))
        // this.GetCarUnitStatusUnit('1014207026',localStorage.getItem('token'))
        // this.GetHistory('1014207026','2021-08-16T00:00:00Z','2021-08-17T00:00:00Z',localStorage.getItem('token'))
        // this.GetEventUnit('1014207026',localStorage.getItem('token'),'','')
        // this.GetEventUnit('1014207026',localStorage.getItem('token'),'S','')
        // this.GetEventUnit('1014207026',localStorage.getItem('token'),'','177')
        // this.GetMaintenanceList(localStorage.getItem('token'),'142','2021-11-01','2021-12-01')
        // this.GetMaintenancePlateNumInfo(localStorage.getItem('token'),'142')
        // this.GetMaintenancePartDetails(localStorage.getItem('token'),'4')
        // this.DaeleteMaintenance(localStorage.getItem('token'),'4')
        //   var Maintenanceobj =
        //   {
        //     objectId: 1465,
        //     driverName: "Josh",
        //     dateOfEntryToRepair: "2021-11-01",
        //     entryRegistryNumber: "entryRegistryNumber",
        //     upToDateMileage: 123,
        //     exitRegistryNumber: "exitRegistryNumber",
        //     locationOfEntry: "locationOfEntry",
        //     nameOfConsultingEngineer: "Josh",
        //     typeOfBreakdown: "M",
        //     breakdownComment: "備註備註",
        //     breakdownStatus: "C",
        //     exitDay: "2021-12-01",
        //     stayDuration: 456,
        //     comment: "備註備註",
        //     maintPartsDetails: [
        //         {
        //             replacementPartId: "1",
        //             brand: "brand1",
        //             vendor: "vendor1",
        //             quantity: 2,
        //             unitPrice: 100,
        //             amount: 200
        //         },
        //         {
        //             replacementPartId: "2",
        //             brand: "brand2",
        //             vendor: "vendor2",
        //             quantity: 2,
        //             unitPrice: 60000,
        //             amount: 120000
        //         }
        //     ]
        // }
         //this.AddMaintenance(localStorage.getItem('token'),JSON.stringify(Maintenanceobj))

        //   var  Maintenanceobj1={
        //     maintId: 6,
        //     driverName: "Josh",
        //     dateOfEntryToRepair: "2021-11-01",
        //     entryRegistryNumber: "123456789",
        //     upToDateMileage: 123123,
        //     exitRegistryNumber: "123456489",
        //     locationOfEntry: "locationOfEntry",
        //     nameOfConsultingEngineer: "Josh",
        //     typeOfBreakdown: "M",
        //     breakdownComment: "備註",
        //     breakdownStatus: "C",
        //     exitDay: "2021-12-01",
        //     stayDuration: 4561,
        //     comment: "備註",
        //     maintPartsDetails: [
        //         {
        //             replacementPartId: "replacementPartId16",
        //             brand: "brand13",
        //             vendor: "vendor12",
        //             quantity: 1,
        //             unitPrice: 2000,
        //             amount: 2000
        //         },
        //         {
        //             replacementPartId: "replacementPartId17",
        //             brand: "brand15",
        //             vendor: "vendor14",
        //             quantity: 2,
        //             unitPrice: 3000,
        //             amount: 6000
        //         }
        //     ]
        // }
        //this.EditMaintenance(localStorage.getItem('token'),JSON.stringify(Maintenanceobj1),'6')
        //this.GetMaintenance(localStorage.getItem('token'),'5')
        //this.GetMaintenancerepairOrders(localStorage.getItem('token'),'142','1465','2021-11-01','2021-12-01')
        //this.GetManageLang('zh-TW')
        //this.GetfleetUnit(localStorage.getItem('token'),142,false,2,1)
        //var Units = ['1008303004','1014207026']
        //this.GetUnitInfoUnits(localStorage.getItem('token'),Units)
        // var Units = ['1014207089','1014207097']
        // this.GetEventAlert(localStorage.getItem('token'),Units)
        //this.GetEventMPG(localStorage.getItem('token'),'1014207016','2021-11-02 07:43:02.000',1)
        //this.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
        // this.GetCameraUploadRecord(localStorage.getItem('token'),'1014207016','20220303022231','20220303022731')
        // this.UploadingPlayBack(localStorage.getItem('token'),3)
        // this.ChangePassword(localStorage.getItem('token'),'demo','demo',this.ErrorConsole)
        // this.SendCommand(localStorage.getItem('token'),'1014207101','log?',this.ErrorConsole)
        // this.GetEventResource(localStorage.getItem('token'))
        // var unitIdArr = ['1002007006']
        // this.DownLoadPositionLogPDF(localStorage.getItem('token'),unitIdArr,'2022-03-29 18:35:59.000','2022-03-31 04:45:23.000',70,162)
        // this.GetPositionLogData(localStorage.getItem('token'),unitIdArr,'2022-03-29 18:35:59.000','2022-03-31 04:45:23.000',70,162)
        // var unitIdArr = ['1002007006']
        // this.GetTripDetail(localStorage.getItem('token'),unitIdArr,'2022-04-05 00:00:00.000','2022-04-07 23:59:00.000')
        // var unitIdArr = ['1001207001']
        // this.GetPairedEventDetail(localStorage.getItem('token'),unitIdArr,'2022-04-06%2016:00:00.000','2022-04-07%2015:59:59.000',162)
      },
      //錯誤印出
      ErrorConsole:function(data, status, statusText){
        console.log('data:')
        console.log(data)
        console.log('status:')
        console.log(status)
        console.log('statusText:')
        console.log(statusText)
        Vue.prototype.$Global.load = false
        Vue.prototype.$Global.Noneactive = ''//開啟網頁操作
        //alert(statusText)
        // console.log('invalid_token:')
        // console.log(data.getResponseHeader('WWW-Authenticate'))
      },
      //登出
      Logout:async function(LoginIndex){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        var Obj ={
          "PK_V4_LoginIndex":LoginIndex
        }
        Obj = JSON.stringify(Obj)
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'auth/Logout',
          accept: "application/json",
          contentType: "application/json",
          data:Obj,
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
          },
          error: function (data, status, statusText,responseJSON) {
              //防止error沒辦法登出
              // Vue.prototype.$router.push({ name: 'Login' }).catch(()=>{})
              // window.location.href = jsonObject['LoginCenter']+jsonObject['SolutionName']+'&Type=Logout'
              Vue.prototype.$Global.Logout('Logout')
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              // this_.InvalidToken(data)
          }
        });
        return result
      },
      //登入
      Login:async function(username,password,LoginError,LoginForToken){
        // console.log(LoginForToken)
        if(LoginForToken != null && LoginForToken!='' && LoginForToken!=undefined){
          try {
            const decodedString = atob(LoginForToken);
            const params = new URLSearchParams(decodedString);
            username = params.get('username');
            password = params.get('password');
          } catch (error) {
              // 捕獲錯誤並處理
              console.error("Error decoding Base64 string:", error.message);
              alert("無法解碼，請檢查輸入是否正確！");
              return 'error'
          }
        }
        var this_=this
        var logindata = {
          grant_type:'password',
          client_id: 'st-fleet-app',
          client_secret: '71E317A2-037A-4416-8F03-D0D5FCA92AC8',
          username: username,
          password: password,
          LoginType:0,
          Lang:localStorage.getItem('Lang'),
          TimeFormat:localStorage.getItem('timeformat'),
          Unit:localStorage.getItem('Unit'),
          Theme:localStorage.getItem('theme')
        }
        var result;
        var RequestTimeout = true
        var xhr;
        //處理無回應情況
        setTimeout(() => {
          if(RequestTimeout){
            xhr.abort()
            //開啟網頁操作
            Vue.prototype.$Global.load = false
            Vue.prototype.$Global.Noneactive = ''
            alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].update_system)
          }
        }, 15000);
        xhr = await Vue.prototype.$.ajax({
            type: 'POST',
            url: this.url+'auth/token',
            contentType: "application/x-www-form-urlencoded",
            data: logindata,
            // xhrFields: { withCredentials: true },
            async:false,
            success: function (data) {
              if(data.unitIDList != '' && data.unitIDList != null){
                result = 'error'
                RequestTimeout = false
                LoginError()
                return result;
              }
              result = 'success'
              this_.dataobj = data
              this_.accounttoken = this_.dataobj.token_type + ' ' +this_.dataobj.access_token
              Vue.prototype.$cookie.set('ul',btoa('SYS'+data.userlevel+'TECH'))
              // localStorage.setItem('ul',btoa('SYS'+data.userlevel+'TECH').replaceAll('N','D').replaceAll('M','C').replaceAll('U','B').replaceAll('=','A').replaceAll('0','O'))
              localStorage.setItem('token',this_.accounttoken)
              localStorage.setItem('username',username)
              localStorage.setItem('logourl',data.logourl)
              localStorage.setItem('PKUserID',data.userID)
              if(data.pK_V4_LoginIndex){
                localStorage.setItem('LoginIndex',data.pK_V4_LoginIndex)
              }
              this_.username = username
              RequestTimeout = false
            },
            error: function (data, status, statusText,responseJSON) {
                result = 'error'
                this_.ErrorConsole(data, status, statusText)
                RequestTimeout = false
                LoginError()
                return result;
                // console.log(data.responseJSON.error_description)
            }
        });
        
        return result;
      },
      //取得LOGO
      GetLogoAddress:function(groupId,token){
        var this_=this
        Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'logos?groupId='+groupId,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        });
      },
      //取得權限
      GetPriority:async function(token){
        var this_=this
        var result = {
          obj:[],
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'function',
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.obj = data
              // this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得車隊列表
      GetFleet:async function(token,ExtraFleetBool){
        var ExtraFleetBoolStr = ''
        if(ExtraFleetBool === false){
          ExtraFleetBoolStr = '/false'
        }else if(ExtraFleetBool === undefined || ExtraFleetBool === null || ExtraFleetBool === true){
          ExtraFleetBoolStr = '/true'
        }
        var this_=this
        var result = {
          Status:'',
          obj:[],
          ErrorMessage:''
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'fleets'+ExtraFleetBoolStr,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              result.obj.subFleets.push(
                {
                  fleetId: result.obj.fleetId,
                  fleetName: result.obj.fleetName,
                  fleetTimeZone: result.obj.fleetTimeZone,
                  googleAPIKey: result.obj.googleAPIKey,
                  parentFleetId: result.obj.parentFleetId,
                  careExpertSiteID: result.obj.careExpertSiteID
                }
              )
              result.obj.subFleets = Vue.prototype.$Global.sortByKey(result.obj.subFleets,'fleetName')
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得車隊車機
      GetCarInfoFleet: async function(fleetID,token,withChild){
        var this_=this
        var result = {
          Status:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'unitInfo/fleets/'+fleetID+'?withChild='+withChild,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data,status,xhr) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得車機資訊
      GetCarInfoUnit:function(UnitID,token){
        var this_=this
        var result = {
          Status:'',
          obj:[]
        }
        Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'unitInfo/units/'+UnitID,
          contentType: "application/x-www-form-urlencoded",
          async:false,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        });
        return result
      },
      // //用車隊取得攝影機狀態 目前沒在用
      // GetCarUnitStatusFleet:function(fleetID,token){
      //   var this_=this
      //   Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: this.url+'unitState/fleets/'+fleetID,
      //     contentType: "application/x-www-form-urlencoded",
      //     headers : {
      //       'Authorization':token,
      //     },
      //     success: function (data) {
      //         this_.dataobj = data
      //         this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
      //     },
      //     error: function (data, status, statusText) {
      //       this_.ErrorConsole(data, status, statusText)
      //       this_.InvalidToken(data)
      //     }
      //   });
      // },
      // //用車輛取得攝影機狀態 目前沒在用
      // GetCarUnitStatusUnit:function(UnitID,token){
      //   var this_=this
      //   Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: this.url+'unitState/units/'+UnitID,
      //     contentType: "application/x-www-form-urlencoded",
      //     headers : {
      //       'Authorization':token,
      //     },
      //     success: function (data) {
      //         this_.dataobj = data
      //         this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
      //     },
      //     error: function (data, status, statusText) {
      //       this_.ErrorConsole(data, status, statusText)
      //       this_.InvalidToken(data)
      //     }
      //   });
      // },
      //取得歷史軌跡
      GetHistory:async function(unitId,startTime,endTime,token,limit){
        if(limit == ''){
          
        }else{
          limit = '&Limit='+limit
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'position/'+unitId+'?startTime='+startTime+'&endTime='+endTime+limit,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
            this_.dataobj = data
            result.Status = 'Success'
            result.obj = this_.dataobj
            this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
            result.Status = 'Error'
            result.msg = statusText
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得事件
      GetEvent:async function(token,fleetID){
        var this_=this
        var url = this.url+'events/fleet/'+fleetID
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: url,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得車機事件
      GetEventUnit:function(UnitID,token,eventtype,reportId){
        var this_=this
        var url = ''
        if(eventtype != ''){
          url = this.url+'events/units/'+UnitID+'?eventType='+eventtype
        }else if(reportId!=''){
          url = this.url+'events/units/'+UnitID+'?reportId='+reportId
        }else{
          url = this.url+'events/units/'+UnitID
        }
        Vue.prototype.$.ajax({
          type: 'GET',
          url: url,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        });
      },
      //取得事件定義
      GetEventDefinition:async function(token,forever){
        var foreverstr = ''
        if(forever == 1){
          foreverstr = '?forever=1'
        }
        var this_=this
        var url = ''
        var result = {
          Status:'',
          obj:[]
        }
        url = this.url+'events/definitions'+foreverstr
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: url,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              result.status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
              // console.log(data)
          },
          error: function (data, status, statusText) {
            result.status = 'error'
            result.obj = []
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        });
        return result
      },
      //FleetWebV4 New API
      //取得CommandList
      // GetCommandList:async function(token,ProtoID){
      //   var this_=this
      //   var url = ''
      //   var result = {
      //     Status:'',
      //     obj:[]
      //   }
      //   url = this.url+'UnitInfo/CommandList?ProtoID='+ProtoID
      //   await Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: url,
      //     contentType: "application/x-www-form-urlencoded",
      //     headers : {
      //       'Authorization':token,
      //     },
      //     success: function (data) {
      //         result.status = 'success'
      //         result.obj = data
      //         this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
      //         // console.log(data)
      //     },
      //     error: function (data, status, statusText) {
      //       result.status = 'error'
      //       result.obj = []
      //       this_.ErrorConsole(data, status, statusText)
      //       this_.InvalidToken(data)
      //     }
      //   });
      //   return result
      // },
      //command APIe
      //取得CommandList
      GetCommandList:async function(token,ProtoID,FleetID){
        var this_=this
        var url = ''
        var result = {
          Status:'',
          obj:[]
        }
        var ProtoIDstr = ''
        if(ProtoID != 0){
          ProtoIDstr = '&ProtoID='+ProtoID
        }
        url = this.url+'ATComm/Query?FleetID='+FleetID+ProtoIDstr
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: url,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              result.status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
              // console.log(data)
          },
          error: function (data, status, statusText) {
            result.status = 'error'
            result.obj = []
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        });
        return result
      },
      //對車機下命令
      SendCommand:async function(token,UnitID,commamdtext,ErrorFunc,password){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        var passwordstr = ''
        if(password != null || password != undefined){
          passwordstr = '&password='+password
        }
        await Vue.prototype.$.ajax({
          type: 'PUT',
          url: this.url +'UnitInfo/freecommand?command='+commamdtext+'&unitId='+UnitID+passwordstr,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
          },
          error: function (data, status, statusText,responseJSON) {
              // console.log(data)
              ErrorFunc(data, status, statusText)
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //新增Command
      AddCommand:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'ATComm/Add',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //編輯Command
      EditCommand:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'ATComm/Upd',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //刪除Command
      DeleteCommand:async function(token,CommandID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'DELETE',
          url: this.url+'ATComm/Del/'+CommandID,
          accept: "application/json",
          contentType: "application/json",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              // alert(data.responseJSON.detail)
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].deleteFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              // console.log(responseJSON)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //command API
      //變更密碼
      ChangePassword:async function(token,OldPassword,NewPassword,ErrorFunc){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url +'UserInfo/changepwd?oldpassword='+OldPassword+'&newpassword='+NewPassword,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
          },
          error: function (data, status, statusText,responseJSON) {
              // console.log(data)
              ErrorFunc(data)
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      // 取得車隊中的車機列表
      GetfleetUnit:async function(token,fleetId,withChild,status,PlateNumber,forever){
        var foreverstr = ''
        if(forever == 1){
          foreverstr = '?forever=1'
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UnitInfo/fleetUnit/'+fleetId+'/'+withChild+'/'+status+'/'+PlateNumber+foreverstr,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得車機array 的資訊
      GetUnitInfoUnits:async function(token,Units,forever){
        var foreverstr = ''
        if(forever == 1){
          foreverstr = '&forever=1'
        }
        var UnitsUrl = this.GetAPIUrlArray('unitId',Units)
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UnitInfo/units'+UnitsUrl+foreverstr,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得緊急事件
      GetEventAlert:async function(token,Units,forever,QueryMin){
        var foreverstr = ''
        var QueryMinStr = ''
        if(QueryMin){
          QueryMinStr = '&QueryMin='+QueryMin
        }
        if(forever == 1){
          foreverstr = '&forever=1'
        }
        var UnitsUrl = this.GetAPIUrlArray('unitId',Units)
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'events/unitlists'+UnitsUrl+foreverstr+QueryMinStr,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得事件影片MP4
      GetEventMPG:async function(token,UnitID,DateT,Num,forever){
        var foreverstr = ''
        if(forever == 1){
          foreverstr = '&forever=1'
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Cameras/CameraRecord/'+UnitID +'?DateT='+DateT+'&Num='+Num + foreverstr,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得可上傳的事件回放錄影
      GetCameraUploadRecord:async function(token,UnitID,StartTime,EndTime,GetCameraUploadRecordErrorFunc){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url +'cameras/CameraUploadRecord?UnitID='+UnitID+'&StartTime='+StartTime+'&EndTime='+EndTime,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
              // console.log(result.obj)
          },
          error: function (data, status, statusText,responseJSON) {
              // console.log(data)
              GetCameraUploadRecordErrorFunc(data)
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //上傳事件回放
      UploadingPlayBack:async function(token,uploadID,Errorfunc,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url +'cameras/CameraUploadRecord?UploadID='+uploadID,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
              // console.log(result.obj)
          },
          error: function (data, status, statusText,responseJSON) {
              // console.log(data)
              // console.log(obj)
              Errorfunc(data,obj)
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //Report API
      //取得V2.5報表URL
      GetReportURL:async function(token,lang,bgclr){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'ReportCode?lang='+lang+'&bgclr='+bgclr,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              localStorage.setItem('2.5ReportUrl',data)
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得成隊事件
      // GetPairedEventDetail:async function(token,unitIdArr,startTime,endTime,reportId){
      //   var UnitsUrl = this.GetAPIUrlArray('unitId',unitIdArr)
      //   var this_=this
      //   var result = {
      //     Status:'',
      //     msg:'',
      //     obj:[]
      //   }
      //   await Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: this.url + 'Position/PairedEventData'+UnitsUrl+'&startTime='+startTime+'&endTime='+endTime+'&reportId='+reportId,
      //     contentType: "application/x-www-form-urlencoded",
      //     headers : {
      //       'Authorization':token,
      //     },
      //     success: function (data) {
      //         this_.dataobj = data
      //         // console.log(data)
      //         result.Status = 'Success'
      //         result.obj = this_.dataobj
      //         this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
      //     },
      //     error: function (data, status, statusText,responseJSON) {
      //         result.Status = 'Error'
      //         result.msg = statusText
      //         this_.ErrorConsole(data, status, statusText)
      //         this_.InvalidToken(data)
      //     }
      //   });
      //   return result
      // },
      //取得成隊事件 post版本
      PostPairedEventDetail:async function(token,IDArr,startTime,endTime,reportId,type,ReportIDArray){
        var Obj;
        if(type == 'identifier'){
          Obj = {
            unitId:IDArr.join()
          }
        }else{
          Obj = {
            driverId:IDArr.join()
          }
        }
        if(ReportIDArray != null && ReportIDArray != undefined && ReportIDArray.length!=0){
          Obj.reportId = ReportIDArray.join()
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/PairedEventData?startTime='+startTime+'&endTime='+endTime+'&reportId='+reportId,
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              // console.log(data)
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得事件
      // GetEventSummary:async function(token,unitIdArr,startTime,endTime,reportId){
      //   var UnitsUrl = this.GetAPIUrlArray('unitId',unitIdArr)
      //   var this_=this
      //   var result = {
      //     Status:'',
      //     msg:'',
      //     obj:[]
      //   }
      //   var ReportID_ = '&ReportID='+reportId
      //   if(reportId == 0){
      //     ReportID_ = ''
      //   }
      //   await Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: this.url + 'Position/EventSummaryData'+UnitsUrl+'&startTime='+startTime+'&endTime='+endTime+ReportID_,
      //     contentType: "application/x-www-form-urlencoded",
      //     headers : {
      //       'Authorization':token,
      //     },
      //     success: function (data) {
      //         this_.dataobj = data
      //         // console.log(data)
      //         result.Status = 'Success'
      //         result.obj = this_.dataobj
      //         this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
      //     },
      //     error: function (data, status, statusText,responseJSON) {
      //         result.Status = 'Error'
      //         result.msg = statusText
      //         this_.ErrorConsole(data, status, statusText)
      //         this_.InvalidToken(data)
      //     }
      //   });
      //   return result
      // },
      //取得事件 post版本
      POSTEventSummary:async function(token,IDArr,startTime,endTime,reportId,type,ReportIDArray){
        var Obj 
        if(type == 'identifier'){
          Obj= {
            unitId:IDArr.join()
          }
        }else{
          Obj= {
            driverId:IDArr.join()
          }
        }
        if(ReportIDArray != null && ReportIDArray != undefined && ReportIDArray.length!=0){
          Obj.reportId = ReportIDArray.join()
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        var ReportID_ = '&ReportID='+reportId
        if(reportId == 0){
          ReportID_ = ''
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/EventSummaryData?startTime='+startTime+'&endTime='+endTime+ReportID_,
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              // console.log(data)
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得事件定義
      GetEventResource:async function(token){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Position/EventMessage/',
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              Vue.prototype.$Report.EventResourceArr = result.obj.eventMessage
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
              // console.log(this_.dataobj)
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //下載PositionLogPDF
      DownLoadPositionLogPDF:async function(token,unitIdArr,startTime,endTime,Speeding,ReportID){
        var UnitsUrl = this.GetAPIUrlArray('unitId',unitIdArr)
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        var Speeding_ = '&Speeding=' + Speeding
        var ReportID_ = '&ReportID='+ReportID
        if(Speeding == 0){
          Speeding_ = ''
        }
        if(ReportID == -1){
          ReportID_ = ''
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Position/LogDetail'+UnitsUrl+'&startTime='+startTime+'&endTime='+endTime+Speeding_+ReportID_,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          xhrFields: {
            // 將回傳結果以 Blob ，也就是保持原本二進位的格式回傳
            responseType: "blob"
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              var href = URL.createObjectURL(data);
              // var href = result.obj
              var link = document.createElement("a");
              document.body.appendChild(link);
              link.href = href;
              link.download = 'Position Log Detail' + new Date().toLocaleString()  + '.pdf';
              link.click();
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得PositionLog資料
      // GetPositionLogData:async function(token,unitIdArr,startTime,endTime,Speeding,ReportID){
      //   var UnitsUrl = this.GetAPIUrlArray('unitId',unitIdArr)
      //   var this_=this
      //   var result = {
      //     Status:'',
      //     msg:'',
      //     obj:[]
      //   }
      //   var Speeding_ = '&Speeding=' + Speeding
      //   var ReportID_ = '&ReportID='+ReportID
      //   if(Speeding == 0){
      //     Speeding_ = ''
      //   }
      //   if(ReportID == -1){
      //     ReportID_ = ''
      //   }
      //   await Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: this.url + 'Position/LogDetailData'+UnitsUrl+'&startTime='+startTime+'&endTime='+endTime+Speeding_+ReportID_,
      //     contentType: "application/x-www-form-urlencoded",
      //     headers : {
      //       'Authorization':token,
      //     },
      //     success: function (data) {
      //         this_.dataobj = data
      //         result.Status = 'Success'
      //         result.obj = this_.dataobj
      //         this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
      //     },
      //     error: function (data, status, statusText,responseJSON) {
      //         result.Status = 'Error'
      //         result.msg = statusText
      //         this_.ErrorConsole(data, status, statusText)
      //         this_.InvalidToken(data)
      //     }
      //   });
      //   return result
      // },
      //取得PositionLogData 資料 post版本
      PostPositionLogData:async function(token,IDArr,startTime,endTime,Speeding,ReportID,type,ReportIDArray){
        var Obj;
        if(type == 'identifier'){
          Obj = {
            unitId:IDArr.join()
          }
        }else{
          Obj = {
            driverId:IDArr.join()
          }
        }
        if(ReportIDArray != null && ReportIDArray != undefined && ReportIDArray.length!=0){
          Obj.reportId = ReportIDArray.join()
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        var Speeding_ = '&Speeding=' + Speeding
        var ReportID_ = '&ReportID='+ReportID
        if(Speeding == 0){
          Speeding_ = ''
        }
        if(ReportID == -1){
          ReportID_ = ''
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/LogDetailData?startTime='+startTime+'&endTime='+endTime+Speeding_+ReportID_,
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得TripDetail 資料
      // GetTripDetail:async function(token,unitIdArr,startTime,endTime){
      //   var UnitsUrl = this.GetAPIUrlArray('unitId',unitIdArr)
      //   var this_=this
      //   var result = {
      //     Status:'',
      //     msg:'',
      //     obj:[]
      //   }
      //   await Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: this.url + 'Position/TripDetailData'+UnitsUrl+'&startTime='+startTime+'&endTime='+endTime,
      //     contentType: "application/x-www-form-urlencoded",
      //     headers : {
      //       'Authorization':token,
      //     },
      //     success: function (data) {
      //         this_.dataobj = data
      //         result.Status = 'Success'
      //         result.obj = this_.dataobj
      //         this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
      //     },
      //     error: function (data, status, statusText,responseJSON) {
      //         result.Status = 'Error'
      //         result.msg = statusText
      //         this_.ErrorConsole(data, status, statusText)
      //         this_.InvalidToken(data)
      //     }
      //   });
      //   return result
      // },
      //取得TripDetail 資料 post版本
      PostTripDetail:async function(token,IDArr,startTime,endTime,type){
        var Obj;
        if(type == 'identifier'){
          Obj = {
            unitId:IDArr.join()
          }
        }else{
          Obj = {
            driverId:IDArr.join()
          }
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/TripDetailData?startTime='+startTime+'&endTime='+endTime,
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得CANGO 資料
      PostCanGoDetail:async function(token,IDArr,startTime,endTime,type){
        var Obj;
        if(type == 'identifier'){
          Obj = {
            UnitID:IDArr.join(),
            StartDateTime:startTime,
            EndDateTime:endTime
          }
        }else{
          Obj = {
            driverId:IDArr.join()
          }
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/CANGODetail',
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得OBDVota 資料
      PostOBDVotaDetail:async function(token,IDArr,startTime,endTime,type){
        var Obj;
        if(type == 'identifier'){
          Obj = {
            UnitID:IDArr.join(),
            StartDateTime:startTime,
            EndDateTime:endTime
          }
        }else{
          Obj = {
            driverId:IDArr.join()
          }
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/OBDVotaDetail',
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得TripSummary資料
      // GetTripSummary:async function(token,unitIdArr,startTime,endTime){
      //   var UnitsUrl = this.GetAPIUrlArray('unitId',unitIdArr)
      //   var this_=this
      //   var result = {
      //     Status:'',
      //     msg:'',
      //     obj:[]
      //   }
      //   await Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: this.url + 'Position/TripSummaryData'+UnitsUrl+'&startTime='+startTime+'&endTime='+endTime,
      //     contentType: "application/x-www-form-urlencoded",
      //     headers : {
      //       'Authorization':token,
      //     },
      //     success: function (data) {
      //         this_.dataobj = data
      //         result.Status = 'Success'
      //         result.obj = this_.dataobj
      //         this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
      //     },
      //     error: function (data, status, statusText,responseJSON) {
      //         result.Status = 'Error'
      //         result.msg = statusText
      //         this_.ErrorConsole(data, status, statusText)
      //         this_.InvalidToken(data)
      //     }
      //   });
      //   return result
      // },
      //取得TripSummary資料 post版本
      PostTripSummary:async function(token,unitIdArr,startTime,endTime){
        var Obj = {
          unitId:unitIdArr.join()
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/TripSummaryData?startTime='+startTime+'&endTime='+endTime,
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得MileageDaySummary資料
      // MileageDaySummary:async function(token,unitIdArr,startTime,endTime){
      //   var UnitsUrl = this.GetAPIUrlArray('unitId',unitIdArr)
      //   var this_=this
      //   var result = {
      //     Status:'',
      //     msg:'',
      //     obj:[]
      //   }
      //   await Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: this.url + 'Position/MileageDaySummaryData'+UnitsUrl+'&startTime='+startTime+'&endTime='+endTime,
      //     contentType: "application/x-www-form-urlencoded",
      //     headers : {
      //       'Authorization':token,
      //     },
      //     success: function (data) {
      //         this_.dataobj = data
      //         result.Status = 'Success'
      //         result.obj = this_.dataobj
      //         this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
      //     },
      //     error: function (data, status, statusText,responseJSON) {
      //         result.Status = 'Error'
      //         result.msg = statusText
      //         this_.ErrorConsole(data, status, statusText)
      //         this_.InvalidToken(data)
      //     }
      //   });
      //   return result
      // },
      ////取得MileageDaySummary資料 post版本
      POSTMileageDaySummary:async function(token,unitIdArr,startTime,endTime){
        var Obj = {
          unitId:unitIdArr.join()
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/MileageDaySummaryData?startTime='+startTime+'&endTime='+endTime,
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得MileageMonthSummary資料
      // MileageMonthSummary:async function(token,unitIdArr,startTime,endTime){
      //   var UnitsUrl = this.GetAPIUrlArray('unitId',unitIdArr)
      //   var this_=this
      //   var result = {
      //     Status:'',
      //     msg:'',
      //     obj:[]
      //   }
      //   await Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: this.url + 'Position/MileageMonthSummaryData'+UnitsUrl+'&startTime='+startTime+'&endTime='+endTime,
      //     contentType: "application/x-www-form-urlencoded",
      //     headers : {
      //       'Authorization':token,
      //     },
      //     success: function (data) {
      //         this_.dataobj = data
      //         result.Status = 'Success'
      //         result.obj = this_.dataobj
      //         this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
      //     },
      //     error: function (data, status, statusText,responseJSON) {
      //         result.Status = 'Error'
      //         result.msg = statusText
      //         this_.ErrorConsole(data, status, statusText)
      //         this_.InvalidToken(data)
      //     }
      //   });
      //   return result
      // },
      //取得MileageMonthSummary資料 post版本
      POSTMileageMonthSummary:async function(token,unitIdArr,startTime,endTime){
        var Obj = {
          unitId:unitIdArr.join()
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/MileageMonthSummaryData?startTime='+startTime+'&endTime='+endTime,
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得FuelMonthSummary資料
      // FuelMonthSummary:async function(token,unitIdArr,startTime,endTime){
      //   var UnitsUrl = this.GetAPIUrlArray('unitId',unitIdArr)
      //   var this_=this
      //   var result = {
      //     Status:'',
      //     msg:'',
      //     obj:[]
      //   }
      //   await Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: this.url + 'Position/FuelMonthSummaryData'+UnitsUrl+'&startTime='+startTime+'&endTime='+endTime,
      //     contentType: "application/x-www-form-urlencoded",
      //     headers : {
      //       'Authorization':token,
      //     },
      //     success: function (data) {
      //         this_.dataobj = data
      //         result.Status = 'Success'
      //         result.obj = this_.dataobj
      //         this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
      //     },
      //     error: function (data, status, statusText,responseJSON) {
      //         result.Status = 'Error'
      //         result.msg = statusText
      //         this_.ErrorConsole(data, status, statusText)
      //         this_.InvalidToken(data)
      //     }
      //   });
      //   return result
      // },
      //取得FuelMonthSummary資料 post版本
      POSTFuelMonthSummary:async function(token,unitIdArr,startTime,endTime){
        var Obj = {
          unitId:unitIdArr.join()
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/FuelMonthSummaryData?startTime='+startTime+'&endTime='+endTime,
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得VehicleAliv資料
      GetVehicleAlive:async function(token,FleetID,OfflineDuration){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Position/VehicleAliveData?fleetId='+FleetID+'&OfflineDuration='+OfflineDuration,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //Report API
      //Manage API
      //取得POIicon
      GetPOIicon:async function(token){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'FleetPOI/ICON',
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              Vue.prototype.$Manage.POIIconList = result.obj.iconImage
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得POI列表
      GetPOIList:async function(token,fleetID,keyword){
        var _keyword = ''
        if(keyword != ''){
          _keyword = '&KeyWord='+keyword
        }
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'FleetPOI/Query?FleetID='+fleetID+_keyword,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //新增POI
      AddPOI:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'FleetPOI/Add',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //編輯POI
      EditPOI:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'FleetPOI/Upd',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //刪除POI
      DeletePOI:async function(token,POIID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'DELETE',
          url: this.url+'FleetPOI/Del/'+POIID,
          accept: "application/json",
          contentType: "application/json",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              // alert(data.responseJSON.detail)
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].deleteFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              // console.log(responseJSON)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //匯入POI
      ImportPOI:async function(token,FleetID,IconID,inherit,file){
        var this_=this
        var formData = new FormData();
        formData.append("file", file);
        var Url = this.url+'FleetPOI/UploadPOI?FleetID='+FleetID+'&IconID='+IconID+'&Inherit='+(inherit?1:0).toString()
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: Url,
          accept: "application/json",
          contentType: "application/json",
          data: formData, 
          cache: false, 
          processData: false, 
          contentType: false, 
          headers : {
            'Authorization':token,
          },
          success: function (data) {
            this_.dataobj = data
            this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
            alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addedSuccessfully)
            Vue.prototype.$Global.load = false
          },
          error: function (data, status, statusText,responseJSON) {
            alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
            Vue.prototype.$Global.load = false
            this_.InvalidToken(data)
          }
        });
      },
      //取得車隊樹
      GetfleetsTree:async function(token){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'fleets/Tree',
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取的Timezone列表
      GetTimezoneList:async function(token){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'fleets/TimeZone',
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              Vue.prototype.$Manage.TimeZoneList = Vue.prototype.$Global.sortByKey(this_.dataobj,'timeZone')
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //新增子車隊
      AddSubFleet:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'fleets/Add',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //編輯車隊
      EditFleet:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'fleets/Upd',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //刪除車隊
      DeleteFleet:async function(token,FleetID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'DELETE',
          url: this.url+'fleets/Del/'+FleetID,
          accept: "application/json",
          contentType: "application/json",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              // alert(data.responseJSON.detail)
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].It_is_not_allowed_to_delete_data_that_has_already_been_used)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              // console.log(responseJSON)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //車隊上傳圖片
      UploadImage:async function(token,FleetID,file){
        var this_=this
        var formData = new FormData();
        formData.append("file", file);
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'Fleets/UploadLogo/'+FleetID,
          accept: "application/json",
          data: formData, 
          cache: false, 
          processData: false, 
          contentType: false, 
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
              Vue.prototype.$Manage.ManageGroupAddMessage = Vue.prototype.$Manage.ManageGroupAddMessage + '\n' + Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].Uploaded_image_successfully
              Vue.prototype.$Manage.ManageGroupEditMessage = Vue.prototype.$Manage.ManageGroupEditMessage + '\n' + Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].Uploaded_image_successfully
              if(Vue.prototype.$Manage.ManageGroupType == 'add'){
                alert(Vue.prototype.$Manage.ManageGroupAddMessage)
              }else{
                alert(Vue.prototype.$Manage.ManageGroupEditMessage)
              }
          },
          error: function (data, status, statusText,responseJSON) {
              Vue.prototype.$Manage.ManageGroupAddMessage = Vue.prototype.$Manage.ManageGroupAddMessage + '\n' + Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].Failed_to_upload_image
              Vue.prototype.$Manage.ManageGroupEditMessage = Vue.prototype.$Manage.ManageGroupEditMessage + '\n' + Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].Failed_to_upload_image
              if(Vue.prototype.$Manage.ManageGroupType == 'add'){
                alert(Vue.prototype.$Manage.ManageGroupAddMessage)
              }else{
                alert(Vue.prototype.$Manage.ManageGroupEditMessage)
              }
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
      },
      //取得使用者階級
      GetUserLevel:async function(token){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UserInfo/UserLevel',
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              // console.log(result.obj)
              Vue.prototype.$Manage.UserLevel.userLevel = []
              for(var i = 0 ; i <this_.dataobj.userLevel.length;i++){
                if(this_.dataobj.userLevel[i].pK_UserLevel >= atob(Vue.prototype.$cookie.get('ul')).split('SYS')[1].split('TECH')[0]){
                  Vue.prototype.$Manage.UserLevel.userLevel.push(this_.dataobj.userLevel[i])
                }
                // if(this_.dataobj.userLevel[i].pK_UserLevel > atob(localStorage.getItem('ul').replaceAll('N','D').replaceAll('C','M').replaceAll('B','U').replaceAll('A','=').replaceAll('O','0')).split('SYS')[1].split('TECH')[0]){
                //   Vue.prototype.$Manage.UserLevel.userLevel.push(this_.dataobj.userLevel[i])
                // }
              }
              // console.log(Vue.prototype.$Manage.UserLevel.userLevel)
              // this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得帳號列表
      GetAccountList:async function(token,FleetID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UserInfo/Account/'+FleetID,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得帳號列表
      PostAccountList:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'UserInfo/Account',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
            Vue.prototype.$Global.Noneactive = ''
            Vue.prototype.$Global.load = false
            result.Status = 'Error'
            result.msg = statusText
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        });
        return result
      },
      //新增帳號
      AddAccount:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'UserInfo/Add',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //編輯帳號
      EditAccount:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'UserInfo/Upd',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //刪除帳號
      DeleteAccount:async function(token,userID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'UserInfo/Del/'+userID,
          accept: "application/json",
          contentType: "application/json",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].deleteFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得Protocol Unit列表
      GetProtocolUnitList:async function(token){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UnitInfo/UnitProtocol',
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              Vue.prototype.$Manage.ProtocolUnitList = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得Server Port列表
      GetServerPortList:async function(token){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UnitInfo/ServerPort',
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              Vue.prototype.$Manage.ServerPortList = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得Icon Type列表
      GetIconTypeList:async function(token){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UnitInfo/IconType',
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              Vue.prototype.$Manage.IconTypeList = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得Object Type 列表
      GetObjectTypeList:async function(token){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UnitInfo/ObjectType',
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              Vue.prototype.$Manage.ObjectTypeList = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得駕駛列表
      GetDriverList:async function(token,FleetID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UnitInfo/Driver/'+FleetID,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              Vue.prototype.$Manage.DriverList = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              Vue.prototype.$Manage.DriverList = []
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      EditConfigValue:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PUT',
          url: this.url+'UnitInfo/UpdateVehicleConfig',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      EditConfigMode:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PUT',
          url: this.url+'UnitInfo/UpdateVehicleConfigMode',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得VehicleConfig
      GetVehicleConfig:async function(token,UnitID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UnitInfo/GetVehicleConfig/'+UnitID,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              Vue.prototype.$Manage.DriverList = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              Vue.prototype.$Manage.DriverList = []
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得ConfigMode列表
      GetConfigModeList:async function(token,FleetArray){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'UnitInfo/GetVehicleConfigMode',
          accept: "application/json",
          contentType: "application/json",
          data:FleetArray,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              Vue.prototype.$Manage.DriverList = []
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得Config列表
      GetVehicleConfigList:async function(token){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UnitInfo/GetVehicleConfigList',
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              Vue.prototype.$Manage.DriverList = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              Vue.prototype.$Manage.DriverList = []
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //Post取得車輛列表
      PostVehicleList:async function(token,FleetArray,Keyword){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        var Keyword_ =''
        if(Keyword == ''){
          Keyword_ = ''
        }else{
          Keyword_ = '?KeyWord='+Keyword
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'UnitInfo/Vehicle'+Keyword_,
          accept: "application/json",
          contentType: "application/json",
          data:FleetArray,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              Vue.prototype.$Manage.DriverList = []
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得車輛列表
      GetVehicleList:async function(token,FleetID,Keyword){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        var Keyword_ =''
        if(Keyword == ''){
          Keyword_ = ''
        }else{
          Keyword_ = '?KeyWord='+Keyword
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UnitInfo/Vehicle/'+FleetID+Keyword_,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              Vue.prototype.$Manage.DriverList = []
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //新增車輛
      AddVehicle:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'UnitInfo/Add',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //編輯車輛
      EditVehicle:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'UnitInfo/Upd',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //刪除車輛
      DeleteVehicle:async function(token,objectID,platformname,modemID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'DELETE',
          url: this.url+'UnitInfo/Del/'+objectID+'/'+platformname+'/'+modemID,
          accept: "application/json",
          contentType: "application/json",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].deleteFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得駕駛列表
      GetDriversList:async function(token,FleetID,Keyword){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        var Keyword_ =''
        if(Keyword == ''){
          Keyword_ = ''
        }else{
          Keyword_ = '?KeyWord='+Keyword
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UnitInfo/Drivers/'+FleetID+Keyword_,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              Vue.prototype.$Manage.DriverList = []
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //新增駕駛
      AddDriver:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'UnitInfo/DriverAdd',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //編輯駕駛
      EditDriver:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'UnitInfo/DriverUpd',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //刪除駕駛
      DeleteDriver:async function(token,DriverID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'DELETE',
          url: this.url+'UnitInfo/DriverDel/'+DriverID,
          accept: "application/json",
          contentType: "application/json",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].deleteFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //Manage API
      //FleetWebV4 New API
      //Cmera Manage API
      //取得多語系資料 已廢除 改用前端取得
      GetLang:async function(Lang){
        var this_=this
        localStorage.setItem('Lang',Lang)
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'languagePacks?culture='+Lang,
          contentType: "application/x-www-form-urlencoded",
          success: function (data) {
              this_.dataobj = data
              this_.LangObj = data
              // console.log(this_.LangObj)
          },
          error: function (data, status, statusText) {
            this_.ErrorConsole(data, status, statusText)
          }
        });
      },
      // GetManageLang:async function(Lang){
      //   var this_=this
      //   await Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: this.url+'maintenance/languagePacks?culture='+Lang,
      //     contentType: "application/x-www-form-urlencoded",
      //     success: function (data) {
      //         this_.dataobj = data
      //         this_.ManageLangObj = data
      //         // console.log(this_.ManageLangObj)
      //     },
      //     error: function (data, status, statusText) {
      //       this_.ErrorConsole(data, status, statusText)
      //     }
      //   });
      // },
      //取得udid資訊 OTUS
      GetudidInfo:async function(token,fleetid,searchType){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'cameras/udidInfo/'+fleetid+'?searchType='+searchType,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //新增udid資訊 OTUS
      AddudidInfo:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'cameras/udidInfo',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //編輯udid資訊 OTUS
      EditudidInfo:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'cameras/udidInfo',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得攝影機列表
      Getcameras:async function(token,fleetid){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'cameras/'+fleetid,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得攝影機型態
      Getcameratypes:async function(token){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'cameras/types',
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得攝影機後鏡頭型態
      GetrearTypes:async function(token,cameratype_id){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'cameras/rearTypes/'+cameratype_id,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //新增攝影機
      AddCameras:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'cameras',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //編輯攝影機
      EditCameras:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'cameras',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //Cmera Manage API
      //Maintenance API
      //取得維護列表
      GetMaintenanceList:async function(token,FleetID,StartDate,EndDate){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'maintenance/records?fleetId='+FleetID+'&startDateOfEntryToRepair='+StartDate+'&endDateOfEntryToRepair='+EndDate,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              //console.log(result.obj)
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得維護車牌號碼資訊
      GetMaintenancePlateNumInfo:async function(token,FleetID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'maintenance/objectInfo?fleetId='+FleetID,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
              //console.log(result.obj)
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得維護Part Details
      GetMaintenancePartDetails:async function(token,MaintenanceID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'maintenance/partsDetails/'+MaintenanceID,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
              //console.log(result.obj)
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得維護紀錄
      GetMaintenance:async function(token,MaintenanceID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'maintenance/records/'+MaintenanceID,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
              //console.log(result.obj)
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得維護清單
      GetMaintenancerepairOrders:async function(token,fleetId,objectId,startDateOfEntryToRepair,endDateOfEntryToRepair){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'maintenance/repairOrders?fleetId='+fleetId+'&objectId='+objectId+'&startDateOfEntryToRepair='+startDateOfEntryToRepair+'&endDateOfEntryToRepair='+endDateOfEntryToRepair,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
              //console.log(result.obj)
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //刪除維護清單
      DeleteMaintenance:async function(token,maintId){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'DELETE',
          url: this.url+'maintenance/records/'+maintId,
          accept: "application/json",
          contentType: "application/json",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //新增維護清單
      AddMaintenance:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'maintenance/records',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //編輯維護清單
      EditMaintenance:async function(token,obj,MaintID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PUT',
          url: this.url+'maintenance/records/'+MaintID,
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //Maintenance API
      //MapControl API
      //取得使用者設定的初始經緯度
      GetUserLatLng:async function (token,forever) {
        var foreverstr = ''
        if(forever == 1){
          foreverstr = '?forever=1'
        }
        var this_=this
        var result = {
            Status: '',
            msg: '',
            obj: []
        }
        await Vue.prototype.$.ajax({
            type: 'GET',
            url: this.url + 'userInfo/coordinates'+foreverstr,
            contentType: "application/x-www-form-urlencoded",
            headers: {
                'Authorization': token,
            },
            success: function (data) {
                result.Status = 'success'
                result.obj = data
                if(result.obj.cy == null || result.obj.cx == null || result.obj.cz == null){
                  result.obj.cy = 25.0625
                  result.obj.cx = 121.646
                  result.obj.cz = 18
                }
                this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
            },
            error: function (data, status, statusText) {
                result.Status = 'error'
                result.msg = statusText
                this_.InvalidToken(data)
            }
        });
        return result
      },
      //使用者設定初始經緯度
      SetUserLatLng:async function (token, data,forever) {
        var foreverstr = ''
        if(forever == 1){
          foreverstr = '?forever=1'
        }
        var this_=this
        var result = {
            Status: '',
            msg: '',
            obj: []
        }
        await Vue.prototype.$.ajax({
            type: 'PUT',
            url: this.url + 'userInfo/coordinates'+foreverstr,
            accept: "application/json",
            contentType: "application/json",
            data: data,
            headers: {
                'Authorization': token,
            },
            success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
            },
            error: function (data, status, statusText) {
              result.Status = 'error'
              result.msg = statusText
              this_.InvalidToken(data)
            }
        });
        return result
      },
      //MapControl APi
      //GeoFence API
      //取得GeoFence Pool 自己的池
      GetGeofenceDefView:async function(token,fleetID,keyword){
        var this_ = this
        var keyword_ = ''
        if(keyword != ''){
          keyword_ = '&KeyWord='+keyword
        }
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'GeofenceDef/Query?FleetID='+fleetID+keyword_,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              result.Status = 'error'
              result.msg = statusText
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //取得GeoFence Pool 往上找所有的母車隊+自己的池
      GetGeofenceDefList:async function(token,fleetID,keyword){
        var this_ = this
        var keyword_ = ''
        if(keyword != ''){
          keyword_ = '&KeyWord='+keyword
        }
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'GeofenceDefList/Query?FleetID='+fleetID+keyword_,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              result.Status = 'error'
              result.msg = statusText
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //刪除GeoFence Pool (根車隊GeoFence定義表) 內的Geofence
      DeleteGeofence:async function(token,zoneID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'DELETE',
          url: this.url+'GeofenceDef/Del/'+zoneID,
          accept: "application/json",
          contentType: "application/json",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].deleteFailed)
              result.Status = 'Error'
              result.msg = statusText
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //新增GeoFence Pool (根車隊GeoFence定義表) 內的Geofence
      AddGeofence:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'GeofenceDef/Add',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //修改GeoFence Pool (根車隊GeoFence定義表) 內的Geofence
      EditGeofence:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'GeofenceDef/Upd',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得GeoFence Assign 資料
      GetGeofenceAssign:async function(token,fleetID,keyword){
        var this_ = this
        var keyword_ = ''
        if(keyword != ''){
          keyword_ = '&KeyWord='+keyword
        }
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Geofence/Query?FleetID='+fleetID+keyword_,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              result.Status = 'error'
              result.msg = statusText
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得RootFleet
      GetRootFleet:async function(token,FleetID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'RootFleet/Query?FleetID='+FleetID,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //選擇GeoFence
      ChoiceGeoFence:async function(token,obj,FleetID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'Geofence/Choice?FleetID='+FleetID,
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //上傳CF檔
      UploadCFtoFTPServer:async function(token,obj,FleetID,ProtoID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'Geofence/UploadCF?FleetID='+FleetID+'&ProtoID='+ProtoID,
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].uploadFailed)
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //上傳Bin檔
      UploadBin:async function(token,file,FleetID,ProtoID){
        var this_=this
        var formData = new FormData();
        formData.append("file", file);
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'Firmware/UploadBIN?FleetID='+FleetID+'&ProtoID='+ProtoID,
          accept: "application/json",
          data:formData,
          cache: false, 
          processData: false, 
          contentType: false, 
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].uploadFailed)
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得批次命令列表
      GetBatchCommandJOb:async function(token,FleetID,Type){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'BatchCommandJob/Query?FleetID='+FleetID+'&Type='+Type,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              result.Status = 'error'
              result.msg = statusText
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得批次命令已選車機
      GetBatchCommandJObSelectedUnit:async function(token,JobID){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'BatchCommandDetail/Query?JobID='+JobID,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              result.Status = 'error'
              result.msg = statusText
              this_.InvalidToken(data)
          }
        });
        return result
      },
      Firmwarelist:async function(token,FleetID,Type){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Firmware/Query?FleetID='+FleetID+'&Type='+Type,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              result.Status = 'error'
              result.msg = statusText
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //新增批次命令 type:0:Geofence 1:Bin 2:Command
      AddBatchCommand:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'BatchCommandJob/Add',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //刪除批次命令
      DelBatchCommand:async function(token,JobID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'DELETE',
          url: this.url+'BatchCommandJob/Del/'+JobID,
          accept: "application/json",
          contentType: "application/json",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].deleteFailed)
              result.Status = 'Error'
              result.msg = statusText
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //編輯批次命令 type:0:Geofence 1:Bin 2:Command
      EditBatchCommand:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'BatchCommandJob/Upd',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //選擇車機加入電子圍籬批次命令
      ChoiceUnitsAddtoBatchCommnad:async function(token,obj,JobID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'BatchCommandDetail/Choice?JobID='+JobID,
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        })
        return result
      },
      //取得電子圍籬批次命令狀態
      getBatchCommandJobState:async function(token,JobID){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'BatchCommandStatus/Query?JobID='+JobID,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              // console.log(data)
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              Vue.prototype.$Global.load = false
              result.Status = 'error'
              result.msg = statusText
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得延伸欄位類型列表
      getOBDTypeList:async function(token){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UnitInfo/OBDType',
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              Vue.prototype.$Manage.OBDTypeList = result.obj.obdType
              // console.log( Vue.prototype.$Manage.OBDTypeList)
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              result.Status = 'error'
              result.msg = statusText
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得ACC型列表
      getACCTypeList:async function(token){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UnitInfo/ACCType',
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              // console.log(result.obj)
              Vue.prototype.$Manage.ACCTypeList = result.obj.accType
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              result.Status = 'error'
              result.msg = statusText
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //GeoFence API
      //權限API
      getFunctionbyID:async function(token,Type,ID){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Function/Query?Type='+Type+'&ID='+ID,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              result.Status = 'error'
              result.msg = statusText
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //編輯權限
      addFunctionbyID:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'Function/Add',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        })
        return result
      },
      //用token取得Account列表
      getAccountByToken:async function(token){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'UserInfo/Account/Query',
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              if(data.account && data.account.length>0){
                Vue.prototype.$Manage.ManagerAccountList= Vue.prototype.$Global.sortByKey(data.account,'userName')
              }
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              result.Status = 'error'
              result.msg = statusText
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //權限API
      //取得我的最愛車輛
      // getFavoriteUnits:async function(token,fleetID) {
      //   var this_=this
      //   var result = {
      //     Status:'',
      //     msg:'',
      //     obj:[]
      //   }
      //   await Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: this.url+'UserInfo/MFavorite/Query?FleetID='+fleetID,
      //     accept: "application/json",
      //     contentType: "application/x-www-form-urlencoded",
      //     headers : {
      //       'Authorization':token,
      //     },
      //     success: function (data) {
      //       // Do somthing
      //     },
      //     error: function (data, status, statusText,responseJSON) {
      //       // Do somthing
      //       this_.ErrorConsole(data, status, statusText)
      //       this_.InvalidToken(data)
      //     }
      //   })
      //   return result
      // },
      //新增我的最愛車輛
      addFavoriteUnits:async function(token,UnitID) {
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'UserInfo/MFavorite/Add?UnitID='+UnitID,
          accept: "application/json",
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
            // Do somthing
          },
          error: function (data, status, statusText,responseJSON) {
            // Do somthing
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        })
        return result
      },
      //刪除我的最愛車輛
      delFavoriteUnits:async function(token,UnitID) {
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'UserInfo/MFavorite/Delete?UnitID='+UnitID,
          accept: "application/json",
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
            // Do somthing
          },
          error: function (data, status, statusText) {
            // Do somthing
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        })
        return result
      },
      //查詢出勤日報表
      getTripForDayList:async function(token,UnitID,StartTime,EndDate){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'DailyTripReport/Query?unitId='+UnitID+'&TripDate_S='+StartTime+'&TripDate_E='+EndDate,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //編輯出勤日報表
      editDailyTrip:async function(token,obj,Search){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'DailyTripReport/Edit',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              Search()
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //OSM經緯度轉地址
      coordinateToAddress:async function(lat,lng,lang,index){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: [],
          index:index
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: 'https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat='+lat+'&lon='+lng+'&accept-language='+lang,
          contentType: "application/x-www-form-urlencoded",
          success: function (data) {
              result.Status = 'success'
              result.obj = data
          },
          error: function (data, status, statusText) {
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //Dashboard
      //查詢昨天已使用車輛
      getVehicleUsedYesterday:async function(token,FleetID,UTCTime_S,UTCTime_E){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Dashboard/VehicleUsedYesterday?FleetID='+FleetID+'&UTCTime_S='+UTCTime_S+'&UTCTime_E='+UTCTime_E,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //查詢今天已使用車輛
      getVehicleUsedToday:async function(token,FleetID,UTCTime){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Dashboard/VehicleUsedToday?FleetID='+FleetID+'&UTCTime='+UTCTime,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //查詢當日車輛里程數
      getVehicleMileageToday:async function(token,FleetID,UTCTime)
      {        
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Dashboard/VehicleMileageToday?FleetID='+FleetID+'&UTCTime='+UTCTime,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //查詢昨日車輛里程數
      getVehicleMileageYesterday:async function(token,FleetID,UTCTime_S,UTCTime_E){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Dashboard/VehicleMileageYesterday?FleetID='+FleetID+'&UTCTime_S='+UTCTime_S+'&UTCTime_E='+UTCTime_E,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //查詢當下各車輛狀態數量
      getVehicleStateNum:async function(token,FleetID){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Dashboard/GetUnitStateNum?FleetID='+FleetID,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //Dashboard
      //查詢月出車天數
      getDaysOfUseMonthSummary:async function(token,FleetID,UTCTime_S,UTCTime_E){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'DaysofUse/Query?FleetID='+FleetID+'&UseDate_S='+UTCTime_S+'&UseDate_E='+UTCTime_E,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //查詢備份檔案下載
      getBackupFilesDownload:async function(token,FleetID){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'BackupFilesDownload/Query?FleetID='+FleetID,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //查詢昨天已使用小時數 及 平均數
      getYestodayUsedHour:async function(token,FleetID){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Dashboard/VehicleTripTimeYesterday?FleetID='+FleetID,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //查詢Dash Board Maintenance
      getDashboardMaintenance:async function(token,FleetID){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Dashboard/Maintenance?FleetID='+FleetID,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //取得Maintenance狀態列表
      getMaintItem:async function(token){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'MaintItem/Query',
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              Vue.prototype.$Global.maintItemList = result.obj.maintItem
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //取得Maintenance Schedule
      getMaintenanceSchedule:async function(token,FleetID,KeyWord){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'MaintSchedule/Query?FleetID='+FleetID+'&KeyWord='+KeyWord,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //修改MaintenanceSchedule
      updateMaintenanceSchedule:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'MaintSchedule/Upd',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //新增MaintenanceSchedule
      addMaintenanceSchedule:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'MaintSchedule/Add',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        })
        return result
      },
      //查詢AutoEmailList
      getAutoEmailList:async function(token,FleetID,ReportPeriod,Active){
        var ReportPeriodStr = ''
        var ActiveStr = ''
        if(ReportPeriod != null && ReportPeriod != 'A'){
          ReportPeriodStr = '&ReportPeriod='+ ReportPeriod
        }
        if(Active != null && Active != 'A'){
          ActiveStr = '&Active='+ Active
        }
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'ReportSchedule/Query?FleetID='+FleetID+ReportPeriodStr+ActiveStr,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //刪除AutoEmail項目
      DelReportSchedule:async function(token,ReportScheduleID){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'DELETE',
          url: this.url+'ReportSchedule/Del/'+ReportScheduleID,
          accept: "application/json",
          contentType: "application/json",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].deleteFailed)
              result.Status = 'Error'
              result.msg = statusText
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //新增AutoEmail項目
      AddReportSchedule:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'ReportSchedule/Add',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //修改AutoEmail項目
      EditReportSchedule:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'ReportSchedule/Upd',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //Line 相關API
      //查詢Fleet LineToken 對應的Line User列表
      getLineUserList:async function(token,FleetID){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Line/LineUserList?FleetID='+FleetID,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //查詢車機綁定的LineUser列表
      getUnitBindLineUserList:async function(token,ObjectID){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Line/UnitBindingLineUserList?ObjectID='+ObjectID,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //新增車機綁定的LineUser
      addUnitBindLineUser:async function(token,obj) {
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'Line/UnitBindingLineUser/Add',
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
            // Do somthing
            this_.dataobj = data
            result.Status = 'Success'
            result.obj = this_.dataobj
            this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
            // Do somthing
            alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
            result.Status = 'Error'
            result.msg = statusText
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        })
        return result
      },
      //刪除車機綁定的LineUser
      delUnitBindLineUser:async function(token,obj) {
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'DELETE',
          url: this.url+'Line/UnitBindingLineUser/Del',
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
            // Do somthing
            this_.dataobj = data
            result.Status = 'Success'
            result.obj = this_.dataobj
            this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
            // Do somthing
            alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].deleteFailed)
            result.Status = 'Error'
            result.msg = statusText
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        })
        return result
      },
      //取得車輛Line狀態
      getUnitLineState:async function(token,obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'Line/UnitListLineState',
          accept: "application/json",
          contentType: "application/json",
          data:obj,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //更新Line發訊息狀態
      UpdateLineMessagState:async function(token,Obj) {
        var data = JSON.stringify(Obj)
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'Line/Upd',
          accept: "application/json",
          contentType: "application/json",
          data:data,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得Line群組列表
      getLineGroupList:async function(token,FleetID){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Line/GroupList?FleetID='+FleetID,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //取得Line群組列表
      getLineGroupBindingList:async function(token,FleetID){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Line/GetGroupBindingList?FleetID='+FleetID,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //刪除車機綁定的Line群組
      delBindLineGroup:async function(token,obj) {
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'DELETE',
          url: this.url+'Line/DeleteGroupBinding',
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
            // Do somthing
            this_.dataobj = data
            result.Status = 'Success'
            result.obj = this_.dataobj
            this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
            // Do somthing
            alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].deleteFailed)
            result.Status = 'Error'
            result.msg = statusText
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        })
        return result
      },
      //新增綁定的Line群組
      addBindLineGroup:async function(token,obj) {
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'Line/AddGroupBinding',
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
            // Do somthing
            this_.dataobj = data
            result.Status = 'Success'
            result.obj = this_.dataobj
            this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
            // Do somthing
            alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].addFailed)
            result.Status = 'Error'
            result.msg = statusText
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        })
        return result
      },
      //Line 相關API
      //查詢登入記錄
      getLoginHistory:async function(token,FleetID,SubFleet,UTCTime_S,UTCTime_E){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        if(SubFleet){
          SubFleet = '1'
        }else{
          SubFleet = '0'
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'LoginReport/List?StartDateTime='+UTCTime_S+'&EndDateTime='+UTCTime_E+'&FleetID='+FleetID+'&SubFleet='+SubFleet,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          // xhrFields: { withCredentials: true },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //取得設定
      // getUserSettings:async function(){
      //   var this_ = this
      //   var result = {
      //     Status: '',
      //     msg: '',
      //     obj: []
      //   }
      //   await Vue.prototype.$.ajax({
      //     type: 'GET',
      //     url: this.url + 'UserInfo/GetUserSettings',
      //     contentType: "application/x-www-form-urlencoded",
      //     xhrFields: { withCredentials: true },
      //     success: function (data) {
      //       console.log(data)
      //     },
      //     error: function (data, status, statusText) {
      //         this_.ErrorConsole(data, status, statusText)
      //     }
      //   });
      //   return result
      // },
      //API14 取得ExtraFleet
      getExtraFleet:async function(token,FleetID){
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'fleets/GetExtraFleet/'+FleetID,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //上傳車輛帳單PDF
      UploadBill:async function(token,ObjectID,file){
        var this_=this
        var formData = new FormData();
        formData.append("file", file);
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'UnitInfo/UploadBillPDF/'+ObjectID,
          accept: "application/json",
          data: formData, 
          cache: false, 
          processData: false, 
          contentType: false, 
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].uploadInvoiceFail)
          }
        });
      },
      //取得車隊事件設定
      GetFleetEventDef:async function(token,FleetID) {
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        var FleetStr = ''
        if(FleetID){
          FleetStr = '?fleetID='+FleetID
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url + 'Events/GetFleetEventDef'+FleetStr,
          contentType: "application/x-www-form-urlencoded",
          headers: {
              'Authorization': token,
          },
          success: function (data) {
              result.Status = 'success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              this_.InvalidToken(data)
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //修改車隊事件設定
      UpdateEventDef:async function(token,Obj,ErrFunc,item) {
        var data = JSON.stringify(Obj)
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'PATCH',
          url: this.url+'Events/UpdateEventDef',
          accept: "application/json",
          contentType: "application/json",
          data:data,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
              if(data.status){
                alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editedSuccessfully)
              }else{
                ErrFunc(item)
                alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              }
          },
          error: function (data, status, statusText,responseJSON) {
              ErrFunc(item)
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //刪除車隊事件設定
      DeleteEventDef:async function(token,Obj,ErrFunc,item) {
        var data = JSON.stringify(Obj)
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'DELETE',
          url: this.url+'Events/DeleteEventDef',
          accept: "application/json",
          contentType: "application/json",
          data:data,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
              if(data.status){
                alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editedSuccessfully)
              }else{
                ErrFunc(item)
                alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              }
          },
          error: function (data, status, statusText,responseJSON) {
              ErrFunc(item)
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].editFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //複製車隊事件設定
      CopyEventDef:async function(token,Obj) {
        var data = JSON.stringify(Obj)
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url+'Events/CopyEventDef',
          accept: "application/json",
          contentType: "application/json",
          data:data,
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
              if(data.status){
                alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].copySuccessful)
              }else{
                ErrFunc(item)
                alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].copyFailed)
              }
          },
          error: function (data, status, statusText,responseJSON) {
              ErrFunc(item)
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].copyFailed)
              result.Status = 'Error'
              result.msg = statusText
              // this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得GoogleGeoCoding結果
      getGeoCoding:async function(SeachContent,Type){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        var url_ = ''
        var GoogleKey = ''
        // console.log(localStorage.getItem('GoogleKey'))
        switch (Type) {
          case 'OSM':
            url_ = jsonObject.OSMGeoCoding+'?Search='+SeachContent
            break;
          case 'Google':
            if(jsonObject.GoogleKey){
              GoogleKey = jsonObject.GoogleKey
              url_ = 'https://maps.googleapis.com/maps/api/geocode/json?address='+SeachContent+'&key='+GoogleKey;
            }
            break;        
          default:
            break;
        }
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: url_,
          contentType: "application/x-www-form-urlencoded",
          success: function (data) {
            console.log(data)
            if(GoogleKey == ''){
              if(data){
                if(data.length == 0){
                  result.obj =[];
                  result.msg = 'NoData'
                }else{
                  result.obj ={};
                  result.obj.lat = parseFloat(data[0].lat)
                  result.obj.lng = parseFloat(data[0].lon)
                  result.Status = 'Success'
                  result.msg = 'OK'
                }
              }
            }else{
              if(data.results){
                if(data.status == 'ZERO_RESULTS' || data.status == 'REQUEST_DENIED'){
                  result.obj =[];
                  result.msg = 'DoOSM'
                }else{
                  if(data.results.length ==0){
                    result.obj =[];
                    result.msg = 'DoOSM'
                  }else{
                    result.obj = data.results[0].geometry.location
                    result.Status = 'Success'
                    result.msg = 'OK'
                  }
                }
              }
            }
          },
          error: function (data, status, statusText) {
            Vue.prototype.$Global.load = false

            result.Status = 'Error'
            result.msg = statusText
            this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //取得冷鏈溫度報表
      getColdChainTemperatureReport:async function (token,Obj) {
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/ColdChainTemperatureReport',
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              this_.dataobj = data
              result.Status = 'Success'
              result.obj = this_.dataobj
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText,responseJSON) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得MDVR回放列表
      getMDVRPlayBackList:async function(MDVRID,date,ch) {
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        // 20240515
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: jsonObject.MDVRAPIUrl+"/command/list?id="+MDVRID+"&ch="+ch+"&date="+date,
          // url:jsonObject.ConvertToHttpUrl+"?mode=list&id="+MDVRID+"&date="+date,
          contentType: "application/x-www-form-urlencoded",
          success: function (data) {
              result.Status = 'success'
              result.obj = data
          },
          error: function (data, status, statusText) {
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //取得MDVR On Demand回放列表
      getMDVRPlayBackList2:async function(MDVRID,date,ch) {
        var this_ = this
        var result = {
          Status: '',
          msg: '',
          obj: []
        }
        // 20240515
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: jsonObject.MDVRAPIUrl+"/command/list2?id="+MDVRID+"&ch="+ch+"&date="+date,
          // url:jsonObject.ConvertToHttpUrl+"?mode=list2&id="+MDVRID+"&date="+date+"&ch="+ch,
          contentType: "application/x-www-form-urlencoded",
          success: function (data) {
              result.Status = 'success'
              result.obj = data
          },
          error: function (data, status, statusText) {
              this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //嘗試回放Url
      tryPlayBackUrl:async function(Url){
        var this_ = this
        var result = ''
        await Vue.prototype.$.ajax({
          type: 'GET',
          url: Url,
          contentType: "application/x-www-form-urlencoded",
          success: function (data) {
            result = data
          },
          error: function (data, status, statusText) {
            this_.ErrorConsole(data, status, statusText)
          }
        });
        return result
      },
      //取得FtpSensor圖片
      GetFtpSensorImg: async function(token, filePath) {
        var this_ = this;
        await Vue.prototype.$.ajax({
            type: "GET",
            url: this.url + "Events/GetFtpSensorImg?filePath=" + filePath,
            contentType: "application/x-www-form-urlencoded",
            headers: {
              "Authorization": token
            },
            success: function(data) {
              console.log(data)
            },
            error: function(xhr, status, statusText) {
                this_.InvalidToken(xhr);
                this_.ErrorConsole(xhr, status, statusText);
            }
        });
      },
      //取得FtpSensor圖片列表
      GetFtpSensorImgList: async function(token){
        var this_ = this;
        await Vue.prototype.$.ajax({
            type: "GET",
            url: this.url + "Events/GetFtpFileList",
            contentType: "application/x-www-form-urlencoded",
            headers: {
              "Authorization": token
            },
            success: function(data) {
              console.log(data)
            },
            error: function(xhr, status, statusText) {
                this_.InvalidToken(xhr);
                this_.ErrorConsole(xhr, status, statusText);
            }
        });
      },
      //代理Token取得Token
      ProxyTokenGetToken:async function(ProxyToken){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        var Obj={
          "ProxyToken": ProxyToken
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'auth/ProxyTokenGetToken',
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          success: function (response) {
            result = response;
            this_.accounttoken = result.token_type + ' ' +result.access_token
            Vue.prototype.$cookie.set('ul',btoa('SYS'+response.userlevel+'TECH'))
            localStorage.setItem('token',this_.accounttoken)
            localStorage.setItem('username',response.userName)
            localStorage.setItem('logourl',response.logourl)
            localStorage.setItem('PKUserID',response.userID)
            if(response.pK_V4_LoginIndex){
              localStorage.setItem('LoginIndex',response.pK_V4_LoginIndex)
            }
            this_.username = response.username
          },
          error: function (data, status, statusText,responseJSON) {
            result.Status = 'Error'
            result.msg = statusText
            Vue.prototype.$Global.SetlocalStorage()
            //原本不確定有沒有
            // window.location.href = jsonObject['LoginCenter']+jsonObject['SolutionName']+'&Type=Logout'
            Vue.prototype.$Global.Logout('Logout')
            // Vue.prototype.$router.push({ name: 'Login' }).catch(()=>{})
          }
        });
        return result
      },
      //取得1nce Token
      Get1nceToken:async function(){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'api/get1nceToken',
          contentType: 'application/json',   // 確保加這行！！
          success: function (response) {
            result.Status = 'Success'
            result.obj = response;
            // console.log(result)
          },
          error: function (data, status, statusText,responseJSON) {
            result.Status = 'Error'
            result.msg = statusText
            console.log(data)
            Vue.prototype.$Global.load = false
          }
        });
        return result
      },
      //取得1nce 資訊
      Get1nceInfo: async function(Obj){
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'api/get1nceSimQuota',
          contentType: 'application/json',   // 確保加這行！！
          data:JSON.stringify(Obj),
          success: function (response) {
            result.Status = 'Success'
            result.obj = response;
            // console.log(result)
          },
          error: function (data, status, statusText,responseJSON) {
            result.Status = 'Error'
            result.msg = statusText
            console.log(data)
            Vue.prototype.$Global.load = false
          }
        });
        return result
      }, 
      //取得冷鏈資料 POC
      GetColdChainData: async function (token,Obj) {
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/GetColdChainData',
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              result.Status = 'Success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得冷鏈資料 POC 1700
      GetColdChainData1700: async function (token,Obj) {
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/GetColdChainData1700',
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              result.Status = 'Success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //取得冷鏈資料 POC 1701
      GetColdChainData1701: async function (token,Obj) {
        var this_=this
        var result = {
          Status:'',
          msg:'',
          obj:[]
        }
        await Vue.prototype.$.ajax({
          type: 'POST',
          url: this.url + 'Position/GetColdChainData1701',
          accept: "application/json",
          contentType: "application/json",
          data:JSON.stringify(Obj),
          headers : {
            'Authorization':token,
          },
          success: function (data) {
              result.Status = 'Success'
              result.obj = data
              this_.GetNewAccountToken(localStorage.getItem('token'),localStorage.getItem('username'))
          },
          error: function (data, status, statusText) {
              result.Status = 'Error'
              result.msg = statusText
              this_.ErrorConsole(data, status, statusText)
              this_.InvalidToken(data)
          }
        });
        return result
      },
      //(酒測器API) 取得Site List
      GetSiteList:async function(token){
        var this_=this
        var result= []
        Vue.prototype.$.ajax({
          type: 'GET',
          url: this.url+'ExtraDevice/GetSiteList?secret='+this.alcoholTesterAPIKey,
          contentType: "application/x-www-form-urlencoded",
          headers : {
            'Authorization':token,
          },
          success: function (data) {
            // console.log(data.data.sites)
            if(data.data.sites){
              result = data.data.sites
            }
            Vue.prototype.$Manage.ManageGroupSiteList = result
          },
          error: function (data, status, statusText) {
            this_.ErrorConsole(data, status, statusText)
            this_.InvalidToken(data)
          }
        });
      },
      //(酒測器API) 取得酒測結果
      GetAlcoholTestResult: async function(date_start, date_end, site_id, token) {
        var this_ = this;
      
        // 回傳一個 Promise，讓呼叫者可以使用 .then() 或 await
        return new Promise((resolve, reject) => {
          Vue.prototype.$.ajax({
            type: 'GET',
            url: this.url + 'ExtraDevice/GetRecordsByDate?secret=' + this.alcoholTesterAPIKey + '&date_start=' + date_start + '&date_end=' + date_end + '&site_id=' + site_id,
            contentType: "application/x-www-form-urlencoded",
            headers: {
              'Authorization': token,
            },
            success: function(data) {
              let records = [];
              if (data.data && data.data.records) {
                records = data.data.records;
              }
              // 成功時將資料傳遞出去
              resolve(records);
            },
            error: function(data, status, statusText) {
              this_.ErrorConsole(data, status, statusText);
              this_.InvalidToken(data);
              // 失敗時拒絕 Promise
              reject(data);
            }
          });
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/API.js